import { ActionReducerMap } from '@ngrx/store';
import * as pagedGrid from './paged-grid';

export const gridSharedStateFeatureKey = 'grid-shared-state';

export interface GridSharedFeatureState {
  gridInstancesState: pagedGrid.PagedGridInstancesState;
}

export const gridSharedReducers: ActionReducerMap<GridSharedFeatureState> = {
  gridInstancesState: pagedGrid.instancesHandlerReducer,
};
